module.exports = __webpack_public_path__ + "img/northern-star.85c62c12.jpg";